import {ComponentProps, FC} from 'react';

export const IconBendArrow: FC<ComponentProps<'svg'>> = ({
    width = '54',
    height = '131',
    fill = 'var(--color-icon-muted)',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 54 131"
            fill="none"
            {...rest}
        >
            <path
                d="M28.5 130C71.5 96 54 11 1 5M1 5L3.5 11M1 5L6.5 1"
                stroke={fill}
            />
        </svg>
    );
};
